export default __webpack_public_path__ + "static/media/document.d8eada02.svg";